import axios from "axios";

// This value is baked into the production bundle at build time. Compose supplies
// `/api`, which keeps browser traffic on the same public origin as the frontend.
export const API = process.env.REACT_APP_API_BASE_URL;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const TOKEN_KEY = "cm_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) =>
  t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY);

// --- Auth ---
export const authApi = {
  register: (data) => api.post("/auth/register", data).then((r) => r.data),
  login: (data) => api.post("/auth/login", data).then((r) => r.data),
  adminLogin: (data) => api.post("/auth/admin/login", data).then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
};

// --- Cards (admin) ---
export const cardsApi = {
  list: (q, client_id) => api.get("/cards", { params: { ...(q ? { q } : {}), ...(client_id ? { client_id } : {}) } }).then((r) => r.data),
  get: (id) => api.get(`/cards/${id}`).then((r) => r.data),
  getBySlug: (slug) => api.get(`/public/cards/slug/${slug}`).then((r) => r.data),
  create: (data) => api.post("/cards", data).then((r) => r.data),
  update: (id, data) => api.put(`/cards/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/cards/${id}`).then((r) => r.data),
  duplicate: (id) => api.post(`/cards/${id}/duplicate`).then((r) => r.data),
  assign: (id, client_id) => api.put(`/admin/cards/${id}/assign`, { client_id }).then((r) => r.data),
  exportCsvUrl: () => `${API}/cards/export/csv`,
  parseImport: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/cards/import/parse", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  commitImport: (rows, client_id) => api.post("/cards/import/commit", { rows, client_id }).then((r) => r.data),
};

// --- Client-scoped ---
export const clientApi = {
  listCards: (q) => api.get("/client/cards", { params: q ? { q } : {} }).then((r) => r.data),
  updateSettings: (data) => api.put("/client/settings", data).then((r) => r.data),
};

// --- Admin (clients management) ---
export const adminApi = {
  listClients: () => api.get("/admin/clients").then((r) => r.data),
  createClient: (data) => api.post("/admin/clients", data).then((r) => r.data),
  updateClient: (id, data) => api.put(`/admin/clients/${id}`, data).then((r) => r.data),
  deleteClient: (id) => api.delete(`/admin/clients/${id}`).then((r) => r.data),
};

// --- Settings (company + template) ---
export const settingsApi = {
  getCompany: () => api.get("/settings/company").then((r) => r.data),
  setCompany: (data) => api.put("/settings/company", data).then((r) => r.data),
  getTemplate: () => api.get("/settings/template").then((r) => r.data),
  setTemplate: (data) => api.put("/settings/template", data).then((r) => r.data),
};

// --- Uploads ---
export const uploadApi = {
  logo: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/upload/logo", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};

// Nice error extractor for FastAPI 422s
export function apiErrorMessage(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Unexpected error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  return String(d);
}
